import { Routes, RouterModule } from '@angular/router';
import { EmpresaComponent } from './pages/empresa/empresa.component';
import { SucessoComponent } from './pages/sucesso/sucesso.component';
import { AnaliseComponent } from './pages/analise/analise.component';
import { PublicLayoutComponent } from './public-layout.component';
import { EmpresaEditalComponent } from './pages/editais/empresa-edital-root.component';

const publicRoutes: Routes = [
    { path: '', component: PublicLayoutComponent,
        children: [
            { path: 'edital/:idFase', component: EmpresaComponent },
            { path: 'analise', component: AnaliseComponent },
            { path: 'sucesso', component: SucessoComponent },
            { path: 'indicacao', component: SucessoComponent },
            { path: 'empresa-edital', component: EmpresaEditalComponent },
        ]
     },
];

export const PublicRouting = RouterModule.forChild(publicRoutes);



// WEBPACK FOOTER //
// ./src/app/components/_public-layout/public-layout.routing.ts